import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  Divider,
} from "@mui/material";
import { CustomTextField } from "assets/styles/globalStyledComponent";
import TextFieldLabel from "app/components/common/TextFieldLabel";
import DialogHeader from "app/components/common/DialogHeader";

const SaveTemplateModal = ({ open, onClose, onSave, isLoading = false }) => {
  const [templateName, setTemplateName] = useState("");
  const [error, setError] = useState("");

  const handleSave = () => {
    // Validate template name
    const trimmedName = templateName.trim();

    if (!trimmedName) {
      setError("Template name is required");
      return;
    }

    if (trimmedName.length < 3) {
      setError("Template name must be at least 3 characters");
      return;
    }

    if (trimmedName.length > 50) {
      setError("Template name must not exceed 50 characters");
      return;
    }

    // Call the save handler
    onSave(trimmedName);
  };

  const handleClose = () => {
    setTemplateName("");
    setError("");
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ p: "0 !important" }}>
        <DialogHeader title="Save Template As New" handleClose={handleClose} />
      </DialogTitle>

      <DialogContent sx={{ pt: 3 }}>
        <Box>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Enter a unique name for this certificate template. You can use this
            template later for similar certificates.
          </Typography>

          <TextFieldLabel title="Template Name" required />
          <CustomTextField
            fullWidth
            size="small"
            placeholder="e.g., Sports Day Certificate 2024"
            value={templateName}
            onChange={(e) => {
              setTemplateName(e.target.value);
              setError("");
            }}
            error={Boolean(error)}
            helperText={error}
            disabled={isLoading}
            autoFocus
            onKeyPress={(e) => {
              if (e.key === "Enter" && !isLoading) {
                handleSave();
              }
            }}
          />

          <Typography
            variant="caption"
            color="text.secondary"
            sx={{ mt: 1, display: "block" }}
          >
            This will save all current settings including colors, fonts, text
            content, and field styles.
          </Typography>
        </Box>
      </DialogContent>
      <Divider/>

      <DialogActions sx={{ gap: 1 }}>
        <Button
          onClick={handleClose}
          variant="outlined"
          color="primary"
          disabled={isLoading}
        >
          Cancel
        </Button>
        <Button
          onClick={handleSave}
          variant="contained"
          color="secondary"
          disabled={isLoading || !templateName.trim()}
        >
          {isLoading ? "Saving..." : "Save Template"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SaveTemplateModal;
